import CaseDetails from "./CaseDetails";

export default CaseDetails;
